import {SettingsApi} from "./ahoyTypes";
import {useFetch} from "usehooks-ts";

export default function useGetSettings() {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const url = `${baseUrl}/api/v1/settings`;
    const {data: settings} = useFetch<SettingsApi>(url);
    return {settings};
}
